import { B2BProducts, AuthFlowType, StytchB2BUIConfig } from '@stytch/nextjs/b2b'
import { getSharedRedirectURL } from '@/utilities/stytch/config'
import { resolvePatientPortalSessionDurationMinutes } from '@/utilities/stytch/patientPortalSessionDuration'

const RESET_PASSWORD_EXPIRATION_MINUTES = 60

export type PasswordResetConfigOptions = {
  sessionDurationMinutes?: number | null
}

export const getPasswordResetConfig = (
  options: PasswordResetConfigOptions = {},
): StytchB2BUIConfig => {
  const redirectURL = getSharedRedirectURL()
  const sessionDurationMinutes = resolvePatientPortalSessionDurationMinutes(
    options.sessionDurationMinutes,
  )

  return {
    products: [B2BProducts.passwords],
    sessionOptions: { sessionDurationMinutes },
    authFlowType: AuthFlowType.PasswordReset,
    passwordOptions: {
      loginRedirectURL: redirectURL,
      resetPasswordRedirectURL: redirectURL,
      resetPasswordExpirationMinutes: RESET_PASSWORD_EXPIRATION_MINUTES,
    },
  }
}

export const getPatientPasswordResetConfig = (
  options: { sessionDurationMinutes?: number | null } = {},
) => getPasswordResetConfig(options)

export default getPasswordResetConfig
